/* eslint-disable @typescript-eslint/ban-types */

import { UserRight, UserType } from "./user-info";

export type AnyObject<T = any> = Record<string, T>;

export type SelectProperty<Entity> = {
  [P in keyof Entity]?: SelectPropertyHandler<NonNullable<Entity[P]>>;
};

type SelectPropertyHandler<Property> = Property extends Promise<infer I>
  ? SelectPropertyHandler<I> | boolean
  : Property extends Array<infer I>
  ? SelectPropertyHandler<I> | boolean
  : Property extends Function
  ? never
  : Property extends object
  ? SelectProperty<Property>
  : boolean;

export type FindOptionsRelations<Entity> = {
  [P in keyof Entity]?: FindOptionsRelationsProperty<NonNullable<Entity[P]>>;
};

type FindOptionsRelationsProperty<Property> = Property extends Promise<infer I>
  ? FindOptionsRelationsProperty<NonNullable<I>> | boolean
  : Property extends Array<infer I>
  ? FindOptionsRelationsProperty<NonNullable<I>> | boolean
  : Property extends Function
  ? never
  : Property extends Buffer
  ? never
  : Property extends Date
  ? never
  : Property extends object
  ? FindOptionsRelations<Property> | boolean
  : boolean;

// TODO: move next types

export interface UserTokens {
  accessToken?: string;
  refreshToken?: string;
  mfaToken?: string;
}

export interface QueryParamsTable {
  filter?: string;
  value?: string;
  page?: number;
  pageSize?: number;
  asc?: string;
  desc?: string;
  auxFilter?: string;
  auxValue?: string;
}

export enum FileExport {
  csv = "CSV",
}

export interface DataToCsvExport {
  [key: string]: string | number | boolean;
}

export interface UserPermission {
  types: (UserType | "*")[];
  rights: (UserRight | "*")[];
}
